import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { motion } from 'framer-motion'

class InterventionType extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			type: null,
			subject: '',
			loading: false,
			validate: false,
		}
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Notifications')
		this.props.updateShell(null, true, this.props.history.location.pathname)
	}

	selectType = (type) => {
		this.setState({ type })
	}

	handleSubject = (event) => {
		this.setState({ subject: event.target.value })
	}

	canSubmit() {
		return this.state.type !== null && this.state.subject.trim().length > 0
	}

	handleSubmit = () => {
		if (!this.canSubmit() || this.state.loading)
			return
		this.setState({ loading: true })
		const conversation = {
			user: this.props.user._id,
			title: this.state.subject.trim(),
			type: this.state.type,
		}
		this.props.postSubmitConversation(conversation)
		.then(ret => {
			this.setState({ validate: ret._id, loading: false })
		})
		.catch(err => {
			console.log(err)
			this.setState({ loading: false })
		})
	}

	render() {
		if (this.state.validate !== false)
		{
			return <Redirect to={`/nouveau-message/${this.state.validate}`} />
		}
		const { theme, lang_assets } = this.props
		const messages = lang_assets.messages
		const themeColor = '#' + theme.color1
		const { type, subject, loading } = this.state
		const types = [
			{
				key: 'intervention',
				icon: (
					<svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
						<path strokeLinecap="round" strokeLinejoin="round" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
					</svg>
				),
				label: messages.type_intervention,
				desc: messages.type_intervention_desc,
			},
			{
				key: 'message',
				icon: (
					<svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
						<path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
					</svg>
				),
				label: messages.type_question,
				desc: messages.type_question_desc,
			},
		]
		return (
			<div className="min-h-screen bg-white">
				<div className="fixed top-0 w-full z-10 flex items-center h-16 px-5 bg-white border-b border-gray-100">
					<button
						onClick={() => this.props.history.goBack()}
						className="mr-4"
						style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
					>
						<svg className="w-5 h-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
							<path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
						</svg>
					</button>
					<h1 className="text-base font-medium text-gray-800">{messages.new_message}</h1>
				</div>
				<div className="pt-16 px-5">
					<p className="text-sm text-gray-500 mt-8 mb-5">{messages.subject_question}</p>
					<div className="flex flex-col gap-3 mb-8">
						{types.map(({ key, icon, label, desc }) => {
							const isSelected = type === key
							return (
								<motion.button
									key={key}
									whileTap={{ scale: 0.97 }}
									onClick={this.selectType.bind(this, key)}
									className="flex items-center w-full p-4 rounded-2xl border-2 text-left transition-colors"
									style={{
										backgroundImage: 'none',
										backgroundColor: isSelected ? themeColor + '12' : 'white',
										borderColor: isSelected ? themeColor : '#E5E7EB',
									}}
								>
									<div
										className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 mr-4"
										style={{ backgroundColor: isSelected ? themeColor : '#F3F4F6', color: isSelected ? 'white' : '#6B7280' }}
									>
										{icon}
									</div>
									<div>
										<p className="text-sm font-medium" style={{ color: isSelected ? themeColor : '#1F2937' }}>{label}</p>
										<p className="text-xs text-gray-400 mt-0.5">{desc}</p>
									</div>
									{isSelected && (
										<div className="ml-auto w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: themeColor }}>
											<svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
												<path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
											</svg>
										</div>
									)}
								</motion.button>
							)
						})}
					</div>
					{type !== null && (
						<motion.div
							initial={{ opacity: 0, y: 8 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.2 }}
						>
							<label className="block text-sm text-gray-500 mb-2">{messages.subject_label}</label>
							<input
								type="text"
								placeholder={messages.subject_placeholder}
								value={subject}
								onChange={this.handleSubject}
								className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-gray-800 focus:outline-none focus:border-gray-400 bg-gray-50"
							/>
						</motion.div>
					)}
				</div>
				<div className="fixed bottom-0 w-full px-5 pb-6 pt-3 bg-white border-t border-gray-100">
					<motion.button
						whileTap={{ scale: 0.97 }}
						onClick={this.handleSubmit}
						disabled={!this.canSubmit() || loading}
						className="w-full py-3.5 rounded-full text-sm font-medium text-white transition-opacity"
						style={{
							backgroundImage: 'none',
							backgroundColor: this.canSubmit() ? themeColor : '#D1D5DB',
						}}
					>
						{loading ? messages.loading : messages.next_button + ' →'}
					</motion.button>
				</div>
			</div>
		)
	}
}

export default InterventionType
